if (!customElements.get('product-form')) {
  // État « ajouté » commun à tous les boutons d'ajout au panier (fiche produit, cartes, popup, barre collante) :
  // après un ajout confirmé, le contenu du bouton laisse place à une coche animée pendant quelques secondes.
  const PRODUCT_FORM_ADDED_STYLE_ID = 'product-form-added-state-style';
  const PRODUCT_FORM_ADDED_DURATION = 2500;
  const PRODUCT_FORM_ADDED_ICON =
    '<span class="product-form__added-icon" aria-hidden="true">' +
    '<svg viewBox="0 0 24 24" fill="none" focusable="false">' +
    '<path d="M5 12.5l4.5 4.5L19 7.5" pathLength="1" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg></span>';

  function ensureProductFormAddedStyles() {
    if (document.getElementById(PRODUCT_FORM_ADDED_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = PRODUCT_FORM_ADDED_STYLE_ID;
    style.textContent = [
      '.product-form__added-host>:not(.product-form__added-icon):not(.loading__spinner){transition:opacity .15s ease;}',
      '.product-form__added-icon{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;',
      'opacity:0;transform:scale(.6);pointer-events:none;transition:opacity .2s ease,transform .25s ease;}',
      '.product-form__added-icon svg{width:2.2rem;height:2.2rem;overflow:visible;}',
      '.product-form__added-icon path{stroke-dasharray:1;stroke-dashoffset:1;transition:stroke-dashoffset .35s ease .1s;}',
      '.product-form__added-host[data-cart-added]>:not(.product-form__added-icon):not(.loading__spinner){opacity:0;}',
      '.product-form__added-host[data-cart-added]>.product-form__added-icon{opacity:1;transform:none;}',
      '.product-form__added-host[data-cart-added]>.product-form__added-icon path{stroke-dashoffset:0;}',
      '@media (prefers-reduced-motion:reduce){',
      '.product-form__added-host>:not(.product-form__added-icon):not(.loading__spinner),.product-form__added-icon,.product-form__added-icon path{transition:none;}}',
    ].join('');

    document.head.appendChild(style);
  }

  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.clearAddedState();

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            this.showAddedState();
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      showAddedState() {
        const button = this.submitButton;
        if (!button) return;

        ensureProductFormAddedStyles();
        if (!button.querySelector(':scope > .product-form__added-icon')) {
          button.classList.add('product-form__added-host');
          button.insertAdjacentHTML('beforeend', PRODUCT_FORM_ADDED_ICON);
          // L'icône doit exister avant l'état pour que sa transition se joue
          void button.offsetWidth;
        }

        clearTimeout(this.addedStateTimer);
        button.setAttribute('data-cart-added', '');
        this.addedStateTimer = setTimeout(() => button.removeAttribute('data-cart-added'), PRODUCT_FORM_ADDED_DURATION);
      }

      // Un nouvel envoi efface tout de suite la coche du précédent : chargement visible, et jamais de coche à côté d'une erreur
      clearAddedState() {
        clearTimeout(this.addedStateTimer);
        if (this.submitButton) this.submitButton.removeAttribute('data-cart-added');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
